import gql from 'graphql-tag'
import { pickDeep } from '@/helpers'
import _ from 'lodash'

export default config => async payload => {
  const {
    client,
    table,
    alias = 'item',
    allowedFields,
    defaultOutput,
    defaultFragments
  } = config

  const { output = defaultOutput, fragments = defaultFragments || '' } = payload

  const mutation = gql`
      mutation($input: ${table}_insert_input!) {
        ${alias}: insert_${table}_one(object: $input) {
            ${output}
        }
      }
      ${fragments}
    `

  const input = !_.isEmpty(allowedFields)
    ? pickDeep(payload, allowedFields)
    : payload

  const { data } = await client.mutate({
    mutation,
    variables: { input }
  })

  return data[alias]
}
